import { Button, Grid, Typography } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import KenInputField from '../../../global_components/KenInputField';
import KenSelectWrap from '../../../global_components/KenSelect';
import KenLoader from '../../../Components/KenLoader/index';
import KenSnackbar from '../../../Components/KenSnackbar/index';
import {
  getAcademicFilter,
  postProgramBatchSpecialization,
  getNoofSpecialization,
  postNoofSpecialization,
} from '../../../Utils/apiServices';
const Specialization = (props) => {
  const defaultValues = {
    university: '',
    department: '',
    course: '',
    startDate: '',
    endDate: '',
    year: '',
    month: '',
    NoofSpecialization: '',
    program:'',
  };
  const NoofSpecializationoptions = [
    {
      label: '0',
      value: '0',
    },
    {
      label: '1',
      value: '1',
    },
    {
      label: '2',
      value: '2',
    },
    {
      label: '3',
      value: '3',
    },
    {
      label: '4',
      value: '4',
    },
    {
      label: '5',
      value: '5',
    },
    {
      label: '6',
      value: '6',
    },
    {
      label: '7',
      value: '7',
    },
    {
      label: '8',
      value: '8',
    },
    {
      label: '9',
      value: '9',
    },
  ];
  const history = useHistory();
  const [formValues, setFormValues] = useState(defaultValues);
  const [courseOptions, setCourseOptions] = React.useState([]);
  const [countSpec, setCountSpec] = useState(0);

  const [NoofSpecialization, setNoofSpecialization] = useState([]);
  const [SpecializationNumber, setSpecializationNumber] = useState('');

  //   SnackBar
  const [openSnackbar, setOpenSnackbar] = React.useState(false);
  const [snackbarSeverity, setSnackbarSeverity] = React.useState('success');
  const [snackbarMessage, setSnackbarMessage] = React.useState('');

  const handleSnackbarClose = (event, reason) => {
    if (reason === 'clickaway') return;
    setOpenSnackbar(false);
  };

  const handleSnackbarOpen = (severity, message) => {
    setLoading(false);
    setOpenSnackbar(true);
    setSnackbarSeverity(severity);
    setSnackbarMessage(message);
  };

  const [loading, setLoading] = React.useState(false);
  const handlespecializationName = (e, index) => {
    let newFormValues = [...NoofSpecialization];
    newFormValues[index]['value'] = e.target.value;
    setNoofSpecialization(newFormValues);
  };
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    console.log("handleInputChange",name,value);
    console.log("NoofSpecialization",NoofSpecialization);
    setFormValues({
      ...formValues,
      [name]: value,
    });
  };

  const handleFilters = () => {
    // props.setFilters(formValues);
    // props.setIsFiltered(true);
    setFormValues({
      program: '',
      department: '',
      course: '',
      startDate: '',
      endDate: '',
      year: '',
      month: '',
      NoofSpecialization: '',
    });
    setNoofSpecialization([]);

  };
  useEffect(() => {
    if (formValues.program) {
      getNoofSpecialization(formValues.program)
        .then((res) => {
          const NoofSpecialization = [];
          res.length > 0 &&
            res.map((items, index) => {
              const i = index + 1;
              console.log('SpecializationNO',i);
              NoofSpecialization.push({
                NoofSpecialization: 'Specialization Name' + ' ' + i,
                value: items.Name,
                programid: items.programid,
                id: items.id,
                name: 'SpecializationName' + i,
              });
            });
          setFormValues({
            ...formValues,
            NoofSpecialization: res.length.toString(),
          });
          setSpecializationNumber(res.length);
          console.log('res.length', res, res.length);
          setNoofSpecialization(NoofSpecialization);
          setCountSpec(NoofSpecialization.length);
        })
        .catch((error) => {
          handleSnackbarOpen('error','No specialization found');
          setFormValues({...formValues,
            NoofSpecialization: '',
          });
          setNoofSpecialization([]);
          console.log('resresresresres', error);
        });
    }
  }, [formValues.program]);

  useEffect(() => {
    if (formValues.NoofSpecialization < SpecializationNumber) {
      handleSnackbarOpen('error', 'Please valid Specialization');
    } else {
      const diff = formValues.NoofSpecialization - countSpec;
      const slice = NoofSpecialization.slice(0, countSpec);
      console.log('slice', slice);
      const input = [];
      Array(diff)
        .fill()
        .map((x, i) =>
          input.push({
            NoofSpecialization:
              'Specialization Name' + ' ' + (NoofSpecialization.length + i + 1),
            value: '',
            name: 'SpecializationName' + (NoofSpecialization.length + i + 1),
            programid: formValues.program,
          })
        );

      setNoofSpecialization([...slice, ...input]);
    }
  }, [formValues.NoofSpecialization, formValues.program]);

  React.useEffect(() => {
    setLoading(true);
    getAcademicFilter()
      .then((res) => {
        let courseOptions = [];
        Object.entries(res['Academic Program']).map(([item, keyVal]) => {
          courseOptions.push({ label: item, value: keyVal.id });
        });
        setCourseOptions(courseOptions);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  }, []);
  const addSpecialization = () => {
    const specialization = [];
    NoofSpecialization.map((items) => {
      specialization.push({
        Name: items.value,
        programid: items.programid,
        id: items.id
      });
    });

    postNoofSpecialization(specialization)
      .then((res) => {
        handleSnackbarOpen('success', 'Successfully added specialization');
        console.log('resrersrresr', res);
        setTimeout(() => {
          handleFilters();
        }, 500);
      })
      .catch((error) => {
        handleSnackbarOpen('error', error.message);
        console.log('resrersrresr', error);
      });
    console.log('NoofSpecialization', specialization);
    
  };
  return (
    <Grid container spacing={2} style={{ maxWidth: 400 }}>
      {/* <Typography className={classes.heading}>Select Program</Typography> */}
      {loading && <KenLoader />}
      <Grid item xs={12}>
        <KenSelectWrap
          name="program"
          label="Program"
          options={courseOptions}
          value={formValues.program}
          dropdownColor="#FFFFFF"
          onChange={(e) => handleInputChange(e)}
          required
        />
      </Grid>
      <Grid item xs={12}>
        <KenSelectWrap
          name="NoofSpecialization"
          label="No of Specialization"
          options={NoofSpecializationoptions}
          value={formValues.NoofSpecialization}
          dropdownColor="#FFFFFF"
          onChange={(e) => handleInputChange(e)}
          menuItemProps={{
            condition: countSpec,
            menuItemDisabled: true,
          }}
          // menuItemProps={NoofSpecializationoptions}
          required
        />
      </Grid>
      {/* {NoofSpecialization.length > 0 &&
        NoofSpecialization.map((items, index) => {
          console.log('itemsitemsitems,', items);
          return (
            <Grid item xs={12}>
              <KenInputField
                label={items.NoofSpecialization}
                required
                placeholder={items.NoofSpecialization}
                name={items.name}
                onChange={(e) => handlespecializationName(e, index)}
                value={items.value}
              />
            </Grid>
          );
        })} */}
      {NoofSpecialization.length > 0 &&
        NoofSpecialization.map((items, index) => {
          console.log('itemsitemsitems,', items);
          const i=index+1
          return (
            <Grid item xs={12}>
              <KenInputField
                label={`No of Specialization ${i}`}
                required
                placeholder={`No of Specialization ${i}`}
                name={items.name}
                onChange={(e) => handlespecializationName(e, index)}
                value={items.value}
              />
            </Grid>
          );
        })}

      <Grid
        item
        xs={12}
        style={{ display: 'flex', justifyContent: 'flex-end' }}
      >
        <Button
          variant="outlined"
          onClick={handleFilters}
          style={{ height: '37px', marginRight: '10px' }}
        >
          Cancel
        </Button>
        <Button variant="contained" color="primary" onClick={addSpecialization}>
          Submit
        </Button>
      </Grid>
      <KenSnackbar
        message={snackbarMessage}
        severity={snackbarSeverity}
        autoHideDuration={4000}
        open={openSnackbar}
        handleSnackbarClose={handleSnackbarClose}
        position="Bottom-Right"
      />
    </Grid>
  );
};

export default Specialization;
